var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.881 75.27a14.407 14.407 0 01-4.074-4.049 15.03 15.03 0 01-2.233-5.382 131.944 131.944 0 01-.052-51.61 14.9 14.9 0 012.213-5.347c2.222-3.309 5.608-5.573 9.423-6.303a132.03 132.03 0 0151.62-.063l-.007.015a14.764 14.764 0 015.358 2.202 14.457 14.457 0 014.068 4.055 15.077 15.077 0 012.232 5.382 132.043 132.043 0 01.05 51.606 14.825 14.825 0 01-2.21 5.347c-2.226 3.309-5.614 5.573-9.432 6.303a132.06 132.06 0 01-51.611.056A14.75 14.75 0 018.88 75.27z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52.344V27.89c0-3.275 3.722-5.162 6.364-3.226l17.118 12.544c2.214 1.623 2.173 4.942-.08 6.51l-17.117 11.91C33.632 57.473 30 55.575 30 52.344z",
    fill: "#00A1DC"
  })));
}
export default SvgVideoPlay;